// DEPLOY COM O APP ABERTO (06/10/2026).
//
// Desde que cada tela baixa quando é aberta (dashboard.routes.js), quem
// está com o advup aberto durante um deploy fica com a versão velha — e ao
// abrir uma tela pela primeira vez pede um pedaço que o deploy apagou: a
// navegação falha ("Failed to fetch dynamically imported module"). Antes,
// com tudo num pacote só, isso não acontecia.
//
// O conserto é o que os apps fazem: recarregar direto na tela pedida, já na
// versão nova. Uma vez por minuto no máximo, para nunca entrar em laço se o
// problema for outro (sem rede, por exemplo).
const CHAVE = 'advup:recarregou-por-versao';

export const ehPedacoQueSumiu = erro =>
  /Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module|Unable to preload CSS/i.test(
    erro?.message || ''
  );

export const ligarVersaoNova = router => {
  router.onError((erro, para) => {
    if (!ehPedacoQueSumiu(erro)) return;
    let ultima = 0;
    try {
      ultima = Number(window.sessionStorage.getItem(CHAVE)) || 0;
    } catch {
      // sem armazenamento: segue, ainda limitado pela comparação abaixo
    }
    if (Date.now() - ultima < 60000) return;
    try {
      window.sessionStorage.setItem(CHAVE, String(Date.now()));
    } catch {
      // idem
    }
    const destino = para ? router.resolve(para).href : window.location.href;
    window.location.assign(destino);
  });
};
